import React, { useState } from "react";

// Components
import { Button, Form } from 'react-bulma-components';
import { Thumbnail, CompanyDetail } from "shared/components/user";
import { Edit3  } from 'react-feather';


//actions
import { useAuthUser } from 'shared/state';

// Styles
import styles from './AddContact.module.scss';

const AddContact = ({ onAddNewContact, onClose }) => {
    const { Input, Field, Control, Label } = Form;
    const [newContact, setNewContact] = useState({});
    //const [newContactAddress, setNewContactAddress] = useState({});
    const { user } = useAuthUser();

    const replaceNullUndefined = (obj) => {
        return obj === null || obj === undefined ? '' : obj;
    }

    const handleInputChange = (e) => {
        setNewContact(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }
/*
    const handleInputChangeForAddress = (e) => {
        setNewContactAddress(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }
*/
    const handleNewContact = (e) => {
        e.preventDefault();
        //const address = Object.keys(newContactAddress).length ? { address: newContactAddress } : '';
        const newContactObj = {
            ...newContact,
            company_id: 1,
            contact_owner: user.id,
            role: "contact"
        }

        // parent component handles api request
        onAddNewContact(newContactObj);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setNewContact({});
        //setNewContactAddress({});
        onClose();
    }

    const handleOverlayClick = (e) => {
        e.preventDefault();
        onClose();
    }

    return (
        <div className={ styles.wrapper }>
            <div className={ styles.detail }>
                <form onSubmit={ handleNewContact }>
                    <article className={ styles.inner }>
                        <header className={ styles.header }>
                            <h2>New Contact</h2>
                            <div className={ styles.image }>
                                <Thumbnail
                                    size="large"
                                    image={ replaceNullUndefined(newContact.image) }
                                    backgroundColor="grey" />
                                <div className={ styles.edit }>
                                    <Edit3 size={18} />
                                </div>
                            </div>
                        </header>
                        <div className={ styles.user }>
                            <Field>
                                <Label>Name</Label>
                                <Control>
                                    <Input
                                        name="name"
                                        onChange={ handleInputChange }
                                        required
                                        value={ replaceNullUndefined(newContact.name) }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Last Name</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="surname"
                                        required
                                        value={ replaceNullUndefined(newContact.surname) }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Email</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="email"
                                        required
                                        value={ replaceNullUndefined(newContact.email) }
                                        />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Phone Number</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="phone"
                                        type="tel"
                                        value={ replaceNullUndefined(newContact.phone) }
                                        />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Job title</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="job_title"
                                        type="text"
                                        value={ replaceNullUndefined(newContact.job_title) }
                                        />
                                </Control>
                            </Field>
                            { /* <CompanyDetail data={ newContact.company } /> */
                            }

                            <Field>
                                <Label>City</Label>
                                <Control>
                                    <Input
                                        name="city"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.city) }
                                        />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Zip code</Label>
                                <Control>
                                    <Input
                                        name="zip"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.zip) }
                                        />
                                </Control>
                            </Field>

                            <Field>
                                <Label>Country</Label>
                                <Control>
                                    <Input
                                        name="country"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.zip) }
                                        />
                                </Control>
                            </Field>
                        </div>
                        <footer className={ styles.actions }>
                            <Button onClick={ handleCancel }>
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                className={ styles.secondary }>
                                Save Changes
                            </Button>
                        </footer>
                    </article>
                </form>
            </div>
        </div>
    )
}

export default AddContact;
